import { Link } from "react-router-dom";
import { DiscordLogo, InstagramLogo, TwitterLogo } from "@phosphor-icons/react";
import Logo from "./Logo";
import { useCopy } from "../context/CopyContext";

export default function Footer() {
  const { t } = useCopy();
  return (
    <footer className="border-t border-white/10 mt-32 pb-16 pt-16 px-6 md:px-12" data-testid="main-footer">
      <div className="max-w-[1600px] mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10">
          <div className="col-span-2">
            <Logo size={44} />
            <p className="text-white/50 text-sm mt-4 max-w-xs leading-relaxed">
              {t("footer.tagline", "The cinematic resource platform for editors. Curated scenepacks. Premium audio edits. Built by editors, for editors.")}
            </p>
            <div className="flex gap-3 mt-6">
              <a href="https://discord.gg/alphaaudios" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-sm border border-white/10 flex items-center justify-center hover:border-[#880015] hover:text-[#880015] transition" data-testid="social-discord"><DiscordLogo size={18} /></a>
              <a href="https://instagram.com/alphascps" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-sm border border-white/10 flex items-center justify-center hover:border-[#880015] hover:text-[#880015] transition" data-testid="social-instagram"><InstagramLogo size={18} /></a>
              <a href="#" className="w-10 h-10 rounded-sm border border-white/10 flex items-center justify-center hover:border-[#880015] hover:text-[#880015] transition" data-testid="social-twitter"><TwitterLogo size={18} /></a>
            </div>
          </div>
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40 mb-4">Browse</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/audios" className="text-white/70 hover:text-white">Audios</Link></li>
              <li><Link to="/scenepacks" className="text-white/70 hover:text-white">Scenepacks</Link></li>
              <li><Link to="/edits" className="text-white/70 hover:text-white">Edits <span className="ml-1.5 text-[8px] tracking-[0.2em] px-1.5 py-[3px] rounded-full bg-[#880015] text-white align-middle">SOON</span></Link></li>
              <li><Link to="/aa-plus" className="text-white/70 hover:text-white">AA+ Premium</Link></li>
            </ul>
          </div>
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40 mb-4">Community</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/contact" className="text-white/70 hover:text-white">Contact</Link></li>
              <li><Link to="/requests?type=scenepack" className="text-white/70 hover:text-white">Request a scenepack</Link></li>
              <li><Link to="/requests?type=audio" className="text-white/70 hover:text-white">Request an audio</Link></li>
              <li><a href="https://discord.gg/alphaaudios" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white">Discord Server</a></li>
            </ul>
          </div>
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40 mb-4">Legal</div>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="text-white/70 hover:text-white">Terms</a></li>
              <li><a href="#" className="text-white/70 hover:text-white">Privacy</a></li>
              <li><Link to="/dmca" className="text-white/70 hover:text-white" data-testid="footer-dmca">DMCA</Link></li>
            </ul>
          </div>
        </div>
        <div className="divider-line my-10" />
        <div className="flex flex-col md:flex-row justify-between gap-4 text-xs text-white/40 font-mono uppercase tracking-wider">
          <div>© 2026 ALPHA AUDIOS — All rights reserved</div>
          <div>{t("footer.copyright_line", "Crafted for editors who care about every frame.")}</div>
        </div>
      </div>
    </footer>
  );
}
